import {observable, computed} from 'mobx';

export class OrgTimeUnit {
  constructor(organization) {
    this.organization = organization;
  }

  @computed get optOrgTimeUnit() {
    const result = [];
    for(let orgTimeUnit of this.organization.timeUnits) {
      result.push({value: orgTimeUnit.id, text: orgTimeUnit.name});
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./src/aggregate/OrgTimeUnit.js